import * as React from "react";
import Alert from "react-bootstrap/Alert";
import { roomOccupancy, occupancyInfo } from "./OccupancyMessage.module.scss";
import InfoIconTooltip from "../InfoIconTooltip/InfoIconTooltip";

export const RoomOccupancyInfo: React.FC<{
  onClose: (arg0: boolean) => void;
  message:
    | boolean
    | React.ReactChild
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
  className?: string;
}> = (props) => {
  return (
    <Alert
      variant="info"
      id="room-occupancy-info"
      className={`text-start ${
        props.className ? occupancyInfo : roomOccupancy
      }`}
      onClose={() => props.onClose(false)}
      dismissible
    >
      <InfoIconTooltip
        disableTooltip={true}
        content={props.message}
        role="alert"
      />{" "}
      {props.message}
    </Alert>
  );
};
